import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { investingService } from '../../services/investingService';

export const useGetAllocateInfo = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.investing.allocate_info],
    queryFn: () =>
      investingService.allocateInfo().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
